(function () {
    'use strict';
    /*
     * Copyright (c) 2014-15 In Hand Health.
     * All rights reserved.
     */

    /**
     * Controller for a modal dialog that chooses one of a list of items.
     */
    angular
        .module('ihh-common-web')
        .controller('IhhModalItemChooserCtrl', IhhModalItemChooserCtrl);

    IhhModalItemChooserCtrl.$inject = ['$scope', '$modalInstance'];

    function IhhModalItemChooserCtrl($scope, $modalInstance) {

        $scope.config.isModal = true;

        /**
         * Closes the dialog with a negative (Cancel) response.
         * @function cancel
         * @memberOf ihh-common-web.ModalItemChooserCtrl
         */
        $scope.cancel = function() {
            $modalInstance.dismiss('cancel');
        };
    }
})();